import bet_mgm_logo from "apps/BWW_PLAY_HUB/assets/img/bet_mgm.png";
import React from 'react';
import { IEvent } from 'modules/reducers/dashboard';
import {
	EventCardLogo,
	EventCardName,
	EventCardPPHeader,
	EventCardMiddleRow,
	EventCardQuestionNumber,
	EventCardWrapper,
	EventDate,
	EventTimer,
	LiveIcon,
	EventCardBetMGMLogo
} from 'apps/BWW_PLAY_HUB/components';
import logo from 'apps/BWW_PLAY_HUB/assets/img/logos/ppLogo.svg';
import { EnumEventStatus, EnumEventType } from 'apps/BWW_PLAY_HUB/modules/utils/enums';
import moment from 'moment';
import styled from 'styled-components';
import iconLock from 'assets/img/icons/icon-lock.svg';
import points_100 from 'apps/BWW_PLAY_HUB/assets/img/points/100-BR-points.png';

interface IProps {
	event: IEvent;
	className?: string;
}

const LinkStyled = styled.a`
	width: 250px;
	height: 60px;
	border-top: 1px solid #fff;
	color: #362E2C;
	font-family: ${ ( { theme } ) => theme.fonts.semiBold };
	font-size: 14px;
	font-weight: 600;
	letter-spacing: 2px;
	line-height: 14px;
	text-align: center;
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 40px auto 0;
	text-transform: uppercase;
	//position:absolute;
	//bottom: 0;
	//left: 0;
	//right: 0;
	
	&.initial {
		border-top-color: #E3E1DB;
	}
`;

const Points = styled.img`
	max-height: 80px;
	margin-left: 10px;
`;


const PickLink: React.FC<IProps> = ( { event, className } ) => {
	const isScheduled = event.status === EnumEventStatus.Scheduled;
	const text = event.user_made_picks ? 'Edit your Picks' : 'Play Now';
	if ( !isScheduled ) {
		return <LinkStyled href={ `${ process.env.REACT_APP_HUB_URL }/picksandprops/contest/${ event.id }/summary` }>View
			your
			summary</LinkStyled>;
	}

	return <LinkStyled className={ className }
					   href={ `${ process.env.REACT_APP_HUB_URL }/picksandprops/contest/${ event.id }/` }>{ text }</LinkStyled>
};

export const EventCardPP: React.FC<IProps> = ( { event } ) => {
	const { user_made_picks, picks_count, max_picks } = event;

	const start = moment( event.start )
		.format( 'hh:mma, ddd, MMM DD YYYY' );
	const isScheduled = event.status === EnumEventStatus.Scheduled;
	const className = isScheduled && !user_made_picks ? 'initial' : '';
	const picks = event.type === EnumEventType.Daily ? max_picks : `2-${ max_picks }`;
	return (
		<EventCardWrapper className={ className }>
			<EventCardPPHeader>
				<EventCardLogo src={ logo } alt={ 'PicksAndProps' }/>
				<EventCardBetMGMLogo src={bet_mgm_logo} alt={'BetMGMLogo'}/>
				{ event.status === EnumEventStatus.Scheduled ? (
					<EventTimer date={event.start} uniq={event.id}/>
				) : (
					<LiveIcon>
						<img src={iconLock} alt={'Icon lock'}/>
						LIVE
					</LiveIcon>
				)}
				<EventCardName>
					{event.name}
				</EventCardName>
				<EventDate>{start}</EventDate>
				<EventCardMiddleRow>
					<EventCardQuestionNumber background_color={'#312A28'}>
						<p><strong>{user_made_picks ? picks_count : picks}</strong></p>
						<p>questions</p>
						{user_made_picks && <p>answered</p>}
					</EventCardQuestionNumber>

					<Points src={points_100} alt={'100 points'}/>
				</EventCardMiddleRow>
			</EventCardPPHeader>

			<PickLink className={ className } event={ event }/>
		</EventCardWrapper>
	)
};
